/* src/app/modules/cooling-companion/components/cooling-graph/cooling-graph.component.scss */
.cooling-graph-container {
  min-height: 300px;
  min-width: 300px;
}
/*# sourceMappingURL=cooling-graph.component.css.map */
